import { COLORS } from "../styles/uiConstants";

export const reportTemplates = [
  {
    id: "appointments",
    name: "Randevu Özeti",
    description: "Toplam randevu, iptal/gelmedi ve doluluk oranı.",
    category: "Randevu",
    scope: "clinic",
    defaultPeriod: "Son 30 gün",
    defaultPeriodValue: "last30",
    emptyTitle: "Randevu verisi bulunamadı",
    emptyDescription: "Seçilen dönemde randevu kaydı bulunamadı.",
    columns: [
      { key: "date", label: "Tarih", width: 140 },
      { key: "total", label: "Toplam", width: 110, align: "center" },
      { key: "cancelled", label: "İptal", width: 110, align: "center" },
      { key: "noShow", label: "Gelmedi", width: 110, align: "center" },
      { key: "fillRate", label: "Doluluk %", width: 120, align: "center" },
    ],
  },
  {
    id: "patients",
    name: "Hasta Aktifliği",
    description: "Yeni/aktif/pasif hasta dağılımı ve trendleri.",
    category: "Hasta",
    scope: "clinic",
    defaultPeriod: "Son 90 gün",
    defaultPeriodValue: "last90",
    emptyTitle: "Hasta verisi bulunamadı",
    emptyDescription: "Seçilen dönemde hasta verisi bulunamadı.",
    columns: [
      { key: "date", label: "Tarih", width: 140 },
      { key: "new", label: "Yeni", width: 110, align: "center" },
      { key: "active", label: "Aktif", width: 110, align: "center" },
      { key: "passive", label: "Pasif", width: 110, align: "center" },
    ],
  },
  {
    id: "treatments",
    name: "Tedavi Tamamlama",
    description: "Aktif/bitmiş/iptal tedavi oranları ve süreler.",
    category: "Tedavi",
    scope: "clinic",
    defaultPeriod: "Son 6 ay",
    defaultPeriodValue: "last6m",
    emptyTitle: "Tedavi verisi bulunamadı",
    emptyDescription: "Seçilen dönemde tedavi kaydı bulunamadı.",
    columns: [
      { key: "date", label: "Tarih", width: 140 },
      { key: "active", label: "Aktif", width: 110, align: "center" },
      { key: "completed", label: "Tamamlandı", width: 140, align: "center" },
      { key: "cancelled", label: "İptal", width: 110, align: "center" },
      { key: "avgDays", label: "Ort. Süre", width: 140, align: "center" },
    ],
  },
  {
    // Cihaz envanteri — "kullanım süresi / son bağlantı" kolonları KALDIRILDI:
    // cihazlar BLE ile telefona bağlanır, sunucu bir bağlantı geçmişi görmez.
    id: "devices",
    name: "Cihaz Envanteri",
    description: "Sisteme kayıtlı cihazlar, tip dağılımı ve durumları.",
    category: "Cihaz",
    scope: "system",
    defaultPeriod: "Son 30 gün",
    defaultPeriodValue: "last30",
    emptyTitle: "Cihaz verisi bulunamadı",
    emptyDescription: "Seçilen dönemde sisteme tanıtılmış cihaz bulunamadı.",
    columns: [
      { key: "device", label: "Seri No", width: 160 },
      { key: "mac", label: "MAC", width: 160 },
      { key: "type", label: "Tip", width: 90 },
      { key: "status", label: "Durum", width: 120 },
      { key: "patient", label: "Hasta", width: 160 },
      { key: "registeredAt", label: "Kayıt Tarihi", width: 140 },
    ],
  },
  {
    id: "clinics",
    name: "Klinik Karşılaştırma",
    description: "Klinik bazlı performans ve büyüme trendleri.",
    category: "Operasyon",
    scope: "system",
    defaultPeriod: "Son 6 ay",
    defaultPeriodValue: "last6m",
    emptyTitle: "Klinik verisi bulunamadı",
    emptyDescription: "Seçilen dönemde klinik verisi bulunamadı.",
    columns: [
      { key: "clinic", label: "Klinik", width: 200 },
      { key: "appointments", label: "Randevu", width: 120, align: "center" },
      { key: "patients", label: "Hasta", width: 120, align: "center" },
      { key: "growth", label: "Büyüme %", width: 120, align: "center" },
      { key: "score", label: "Performans", width: 140, align: "center" },
    ],
  },
  {
    id: "staff",
    name: "Personel Verimliliği",
    description: "Doktor/sekreter işlem yoğunluğu ve etkinlik.",
    category: "Operasyon",
    scope: "clinic",
    defaultPeriod: "Son 30 gün",
    defaultPeriodValue: "last30",
    emptyTitle: "Personel verisi bulunamadı",
    emptyDescription: "Seçilen dönemde personel verisi bulunamadı.",
    columns: [
      { key: "staff", label: "Personel", width: 180 },
      { key: "role", label: "Rol", width: 120 },
      { key: "actions", label: "İşlem", width: 120, align: "center" },
      { key: "avgTime", label: "Ort. Süre", width: 140, align: "center" },
      { key: "score", label: "Skor", width: 120, align: "center" },
    ],
  },
  {
    id: "security",
    name: "Güvenlik & Audit",
    description: "Kritik aksiyonlar, girişler ve izin değişiklikleri.",
    category: "Güvenlik",
    scope: "system",
    defaultPeriod: "Son 30 gün",
    defaultPeriodValue: "last30",
    emptyTitle: "Audit verisi bulunamadı",
    emptyDescription: "Seçilen dönemde audit verisi bulunamadı.",
    columns: [
      { key: "date", label: "Tarih", width: 160 },
      { key: "action", label: "Aksiyon", width: 160 },
      { key: "user", label: "Kullanıcı", width: 160 },
      { key: "resource", label: "Kaynak", width: 160 },
      { key: "ip", label: "IP", width: 140 },
    ],
  },
];

export const categoryOptions = [
  { value: "all", label: "Tümü" },
  { value: "Randevu", label: "Randevu" },
  { value: "Hasta", label: "Hasta" },
  { value: "Tedavi", label: "Tedavi" },
  { value: "Cihaz", label: "Cihaz" },
  { value: "Operasyon", label: "Operasyon" },
  { value: "Güvenlik", label: "Güvenlik" },
];

export const scopeOptions = [
  { value: "all", label: "Tümü" },
  { value: "system", label: "Sistem" },
  { value: "clinic", label: "Klinik" },
];

export const periodOptions = [
  { value: "last7", label: "Son 7 Gün" },
  { value: "last30", label: "Son 30 Gün" },
  { value: "last90", label: "Son 90 Gün" },
  { value: "thisMonth", label: "Bu Ay" },
  { value: "last6m", label: "Son 6 Ay" },
  { value: "custom", label: "Tarih Aralığı" },
];

export const categoryChipSx = (category) => {
  switch (category) {
    case "Randevu":
      return { bgcolor: "#e0f2fe", color: "#0369a1", fontWeight: 700 };
    case "Hasta":
      return { bgcolor: COLORS.successLight, color: "#15803d", fontWeight: 700 };
    case "Tedavi":
      return { bgcolor: "#ede9fe", color: "#6d28d9", fontWeight: 700 };
    case "Cihaz":
      return { bgcolor: "#fff7ed", color: "#c2410c", fontWeight: 700 };
    case "Operasyon":
      return { bgcolor: COLORS.slate200, color: COLORS.slate700, fontWeight: 700 };
    case "Güvenlik":
      return { bgcolor: COLORS.errorLight, color: "#b91c1c", fontWeight: 700 };
    default:
      return { bgcolor: COLORS.slate100, color: COLORS.slate700, fontWeight: 700 };
  }
};
